var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgreementServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 198,
    viewBox: "0 0 205 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_1202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0996,
    y: 23.6406,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 67.9023,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 77.165,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 86.4277,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 95.6904,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6781 46.8193V47.641C46.6781 48.7304 46.6781 49.9535 46.3245 51.7977L45.1014 51.6735C45.4311 50.0299 45.4454 48.8068 45.455 47.7844H40.3332V46.8193H46.6781ZM47.4426 52.7055V53.6993H39.5114V52.7055H42.3494V49.7146H43.563V52.7055H47.4426ZM55.9279 52.7437V53.7184H47.9681V52.7437H51.2935V50.7753H52.507V52.7437H55.9279ZM52.5453 47.1824C52.5453 48.4246 53.6633 49.7337 55.6508 50.0395L55.1348 51.0524C53.6059 50.7753 52.4688 49.9583 51.8955 48.8737C51.3221 49.9535 50.1946 50.7801 48.6752 51.0524L48.1592 50.0395C50.1277 49.7337 51.2361 48.415 51.2457 47.1824V46.5613H52.5453V47.1824ZM61.3651 46.6473V47.6219H59.6355C59.6451 48.6348 60.2519 49.6143 61.6422 50.0204L61.0593 50.976C60.099 50.6845 59.4349 50.1016 59.0526 49.3515C58.6656 50.2306 57.9585 50.9282 56.9122 51.2722L56.2911 50.3071C57.734 49.8532 58.3837 48.7256 58.4029 47.6219H56.6255V46.6473H61.3651ZM63.324 46.0644V48.0806H64.4993V49.0744H63.324V51.2244H62.1009V46.0644H63.324ZM60.4764 51.3964C62.2824 51.3868 63.41 52.008 63.41 53.0686C63.41 54.1293 62.2824 54.76 60.4764 54.76C58.6322 54.76 57.4951 54.1293 57.4951 53.0686C57.4951 52.008 58.6322 51.3868 60.4764 51.3964ZM60.4764 52.3424C59.3298 52.3424 58.7086 52.5813 58.7182 53.0686C58.7086 53.5655 59.3298 53.814 60.4764 53.814C61.604 53.814 62.206 53.5655 62.206 53.0686C62.206 52.5813 61.604 52.3424 60.4764 52.3424Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_1202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.0791,
    y: 7.2002,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 51.4619,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 60.7246,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 69.9873,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 79.25,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.39 29.6239V31.7166H68.5654V32.7295H67.39V34.7171H66.1669V29.6239H67.39ZM62.9085 35.0515V35.7109H66.1669V35.0515H67.39V38.224H61.6949V35.0515H62.9085ZM62.9085 37.2684H66.1669V36.6473H62.9085V37.2684ZM65.6509 30.3884V31.3439H60.4909V30.3884H62.4689V29.5666H63.6825V30.3884H65.6509ZM63.0709 31.5924C64.3322 31.5924 65.2114 32.2039 65.2114 33.1308C65.2114 34.0577 64.3322 34.6693 63.0709 34.6693C61.7904 34.6693 60.9113 34.0577 60.9113 33.1308C60.9113 32.2039 61.7904 31.5924 63.0709 31.5924ZM63.0709 32.4906C62.488 32.4811 62.0962 32.72 62.1058 33.1308C62.0962 33.5513 62.488 33.7806 63.0709 33.7806C63.6538 33.7806 64.0551 33.5513 64.0551 33.1308C64.0551 32.72 63.6538 32.4811 63.0709 32.4906ZM71.7665 30.2068C73.1425 30.1973 74.1745 31.0955 74.1745 32.3377C74.1745 33.5895 73.1425 34.4782 71.7665 34.4782C70.3905 34.4782 69.3489 33.5895 69.3489 32.3377C69.3489 31.0955 70.3905 30.1973 71.7665 30.2068ZM71.7665 31.2579C71.0785 31.2579 70.553 31.6593 70.5625 32.3377C70.553 33.0257 71.0785 33.4175 71.7665 33.4175C72.4545 33.4175 72.9801 33.0257 72.9896 32.3377C72.9801 31.6593 72.4641 31.2579 71.7665 31.2579ZM76.2577 29.6239V38.3387H75.0441V29.6239H76.2577ZM68.9858 35.5675C70.5338 35.5771 72.6839 35.5484 74.5472 35.2904L74.6428 36.1695C72.7125 36.5422 70.6485 36.5613 69.1292 36.5613L68.9858 35.5675ZM80.6915 31.5924C80.6915 33.2264 81.3508 34.8126 82.8033 35.4433L82.0579 36.418C81.0928 35.945 80.4478 35.0802 80.0895 34.01C79.7072 35.1471 79.0383 36.0788 78.0446 36.5709L77.2801 35.5771C78.7708 34.9082 79.4492 33.2264 79.4588 31.5924V30.2928H80.6915V31.5924ZM84.7431 29.6239V38.3387H83.539V33.3411H81.8286V32.3568H83.539V29.6239H84.7431Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_1202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.423,
    y: 50.793,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    transform: "rotate(18.5895 120.423 50.793)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.751,
    y: 96.9297,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 118.751 96.9297)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.798,
    y: 105.709,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 115.798 105.709)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.846,
    y: 114.489,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 112.846 114.489)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.893,
    y: 123.269,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 109.893 123.269)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.899 82.3481L143.232 84.3316L144.346 84.7062L144.023 85.6663L142.909 85.2916L142.275 87.1755L141.116 86.7856L142.74 81.9581L143.899 82.3481ZM137.921 86.0638L137.711 86.6887L140.799 87.7275L141.009 87.1026L142.169 87.4925L141.157 90.4994L135.759 88.6839L136.771 85.6769L137.921 86.0638ZM137.214 88.165L140.303 89.2038L140.501 88.6151L137.412 87.5763L137.214 88.165ZM142.007 82.5182L141.702 83.4239L136.811 81.779L137.116 80.8733L138.991 81.5038L139.253 80.7249L140.403 81.1118L140.141 81.8907L142.007 82.5182ZM139.178 82.8369C140.373 83.239 141.011 84.0989 140.716 84.9775C140.42 85.856 139.392 86.1554 138.197 85.7533C136.983 85.3451 136.345 84.4852 136.64 83.6067C136.936 82.7281 137.964 82.4287 139.178 82.8369ZM138.891 83.6883C138.342 83.4934 137.894 83.595 137.772 83.9875C137.629 84.3829 137.927 84.7252 138.48 84.911C139.032 85.0968 139.486 85.0074 139.62 84.6089C139.751 84.2194 139.447 83.8651 138.891 83.6883ZM147.861 84.2957C149.168 84.7253 149.86 85.9056 149.464 87.0831C149.065 88.2695 147.804 88.7829 146.5 88.3442C145.195 87.9056 144.491 86.7312 144.89 85.5447C145.286 84.3673 146.56 83.848 147.861 84.2957ZM147.526 85.292C146.874 85.0726 146.248 85.2855 146.041 85.9316C145.812 86.5807 146.186 87.1195 146.838 87.3389C147.49 87.5582 148.113 87.3544 148.341 86.7053C148.548 86.0592 148.187 85.5143 147.526 85.292ZM152.304 85.1749L149.526 93.435L148.375 93.0481L151.154 84.7881L152.304 85.1749ZM143.517 88.4903C144.981 88.9928 147.028 89.651 148.876 90.0005L148.687 90.8642C146.738 90.6021 144.776 89.9622 143.336 89.4779L143.517 88.4903ZM155.879 88.4541C155.358 90.0029 155.477 91.7165 156.653 92.7773L155.636 93.4636C154.872 92.7076 154.536 91.6823 154.538 90.5537C153.813 91.5096 152.882 92.1794 151.783 92.3291L151.375 91.1434C153.001 90.9846 154.18 89.6069 154.71 88.0612L155.125 86.8294L156.293 87.2224L155.879 88.4541ZM160.347 87.88L157.568 96.14L156.427 95.7562L158.02 91.0193L156.399 90.4741L156.713 89.5412L158.334 90.0865L159.205 87.4961L160.347 87.88Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3555,
    y: 157.779,
    width: 6.41458,
    height: 40.5167,
    transform: "rotate(-35 56.3555 157.779)",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2511 150.612L61.6112 154.09L56.3438 157.778L55.2511 150.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5342 135.449L105.884 134.543L111.606 174.654L105.256 175.56L99.5342 135.449Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.789 128.558L105.889 134.535L99.5232 135.444L101.789 128.558Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_1202",
    x: 14.0996,
    y: 23.6406,
    width: 81.3565,
    height: 105.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_1202",
    x: 35.0791,
    y: 7.2002,
    width: 81.3565,
    height: 105.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_1202",
    x: 89.3809,
    y: 51.5947,
    width: 107.666,
    height: 123.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1202",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgreementServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcAgreementServiceBodyMobile.e46f0e2b482b7f2290d51a5c572297ea.svg";
export { ForwardRef as ReactComponent };